import { List, NeoModel } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../App/Services/AppService';
import StaticServiceProviderFileGroupingModel from '../../../Common/Models/StaticServiceProviderFileGroupingModel';
import FreeTextEventMappingLookup from '../Models/Lookups/FreeTextEventMappingLookup';
import Keyword from '../Models/Lookups/Keyword';
import DestinationTableLookup from '../../../Maintenance/GenericMappings/Models/Lookups/DestinationTableLookup';

@NeoModel
export default class ManageFreeTextEventMappingComponentVM extends Views.ViewModelBase {

    constructor(
        public generalApiClient = AppService.get(Types.ApiClients.GeneralApiClient),
        public serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient),
        public rawGenericMappingApiClient = AppService.get(Types.ApiClients.RawGenericMappingApiClient),
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications)) {

        super(taskRunner);
    }

    public fileGroupingList = new List(StaticServiceProviderFileGroupingModel);
    public managedFreeTextMapping = new FreeTextEventMappingLookup();
    public destinationTablesList = new List(DestinationTableLookup);
    public keywordList = new List(Keyword);
    public isFieldReadOnlyInd: boolean = false;

    public async initialise() {
        await this.loadFileGroupings();
        this.keywordList = new List(Keyword);
        await this.setKeywordsList();        
        await this.getDestinationTablesList();
    }

    public clearDestinationField() {
        this.managedFreeTextMapping.destinationFieldId = 0;
        this.managedFreeTextMapping.sourceFieldName = "";
    }

    public async loadFileGroupings() {
        const response = await this.taskRunner.waitFor(this.generalApiClient.getStaticServiceProviderFileGroupingList());
        this.fileGroupingList.set(response.data);
    }

    public async setKeywordsList() {
        this.managedFreeTextMapping.rawGenericServiceProviderEventKeywords.forEach((element) => {
            var keywordItem = new Keyword(element.meta.rawGenericServiceProviderEventKeywordId.value, element.meta.rawGenericServiceProviderEventMappingId.value, element.meta.keyword.value);
            this.keywordList.push(keywordItem);
        })
    }

    public async getDestinationTablesList() {
        const response = await this.taskRunner.waitFor(this.rawGenericMappingApiClient.getDestinationTablesList());
        this.destinationTablesList.set(response.data);
    }
}
